import { combineReducers } from 'redux';
import { ghost as ghostModel } from '@minerva-analytics/pantheon';

import category from './category/reducers';
import horoscope from './horoscope/reducers';
import pending from './pending/reducers';
import sign from './sign/reducers';
import timeframe from './timeframe/reducers';
import compatibility from './compatibility/reducers';
import subscriber from './subscriber/reducers';
import referral from './referral/reducers';

const ghost = combineReducers(ghostModel.reducers);

export default combineReducers({
  category,
  horoscope,
  pending,
  sign,
  timeframe,
  compatibility,
  ghost,
  subscriber,
  referral,
});
